import Vue from "vue";
import VueI18n from "vue-i18n";
// 引入VueCookies
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

const choseLang = cookies.get('okimg_lang');
// const choseLang = localStorage.getItem('lang');
//获取本地选择的语言

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);

    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}
function getLanguage() {
  var lang =
  choseLang ||
  (navigator.language || navigator.userLanguage).split("-")[0] ||
  "en";
  return lang;
}

// locale
export default new VueI18n({
  locale: getLanguage(),
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
});


// WEBPACK FOOTER //
// ./src/i18n/index.js